import { CodefCertificateBase } from '~types/codef';

export interface ConnectedCodefCertificate extends CodefCertificateBase {
  cert: string;
  password: string;
}

export const CodefCertificateHardDiskPath = '';

export interface CreateCertificateRequest {
  initScrape?: boolean;
  certificates: ConnectedCodefCertificate[];
}
